import { Action, createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';
import { OdataEquipmentsModel } from '../../interfaces/equipments-odata.interface';
import {
    getEquipmentsError,
    getEquipmentsSuccess,
    getEquipmentsWithMatSer,
    getEquipmentsWithOrder,
} from '../actions/protocols.action';
import { initialProtocolsState, ProtocolState } from '../state/protocol.state';

function getEquipmentsReducer(state: Readonly<ProtocolState>): Readonly<ProtocolState> {
    return {
        ...state,
        isLoading: true,
    };
}

function getEquipmentsSuccessReducer(
    state: Readonly<ProtocolState>,
    props: { protocols: Readonly<OdataEquipmentsModel> },
): Readonly<ProtocolState> {
    return {
        ...state,
        user: props.protocols.User,
        material: props.protocols.Material,
        serialNo: props.protocols.SerialNo,
        orderNo: props.protocols.OrderNo,
        equipments: _.cloneDeep(props.protocols.EquipmentsSet.results),
        interims: _.cloneDeep(props.protocols.InterimProtocolsSet.results),
        isLoading: false,
    };
}

function getEquipmentsErrorReducer(state: Readonly<ProtocolState>): Readonly<ProtocolState> {
    return {
        ...state,
        ...initialProtocolsState,
    };
}

const createProtocolsReducer = createReducer(
    initialProtocolsState,
    on(getEquipmentsWithOrder, getEquipmentsReducer),
    on(getEquipmentsWithMatSer, getEquipmentsReducer),
    on(getEquipmentsSuccess, getEquipmentsSuccessReducer),
    on(getEquipmentsError, getEquipmentsErrorReducer),
);

export function ProtocolsReducer(state: Readonly<ProtocolState>, action: Action): Readonly<ProtocolState> {
    return createProtocolsReducer(state, action);
}
